import { Markdown } from './markdown'

interface ContentProps {
  content: string
}

export function Content({ content }: ContentProps) {
  return <Markdown>{content}</Markdown>
}
